export default __webpack_public_path__ + "static/media/icon5.4001e6bc.svg";